import React from "react";
import { Restricted, permissions } from "components/auth";
import { AddAction } from "components/buttons";

const ActionButtons = () => (
  <Restricted permissions={[permissions.contract_manage]}>
    <AddAction url={`/contract/new`} />
  </Restricted>
);

export default ActionButtons;
